import React, { useEffect, useState } from "react";
import { Download } from "lucide-react";

/**
 * Shows an "Install app" pill when the browser fires `beforeinstallprompt`
 * (Chrome/Edge/Brave/Opera). Silently returns null on Firefox/Safari or when
 * the app is already running installed. Drop this anywhere in the tree.
 */
export function InstallAppButton({ className = "" }) {
  const [prompt, setPrompt] = useState(null);
  const [installed, setInstalled] = useState(
    typeof window !== "undefined" &&
      (window.matchMedia?.("(display-mode: standalone)").matches ||
        window.navigator.standalone === true)
  );

  useEffect(() => {
    const onBeforeInstall = (e) => {
      e.preventDefault();
      setPrompt(e);
    };
    const onInstalled = () => {
      setInstalled(true);
      setPrompt(null);
    };
    window.addEventListener("beforeinstallprompt", onBeforeInstall);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onBeforeInstall);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (installed || !prompt) return null;

  const onClick = async () => {
    try {
      prompt.prompt();
      await prompt.userChoice;
    } finally {
      setPrompt(null);
    }
  };

  return (
    <button
      type="button"
      data-testid="install-app-btn"
      onClick={onClick}
      className={`inline-flex items-center gap-2 h-9 px-3.5 rounded-full text-[13px] font-semibold bg-white/10 hover:bg-white/15 text-white border border-white/15 transition-colors ${className}`}
      title="Install Vitality Medical Software as a desktop app"
    >
      <Download className="w-4 h-4" /> Install app
    </button>
  );
}

export default InstallAppButton;
